import { lazy } from 'react';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const Calendar = lazy(() => import('@/features/atividade/components/Calendar'));
const AtividadeConfigAreas = lazy(() =>
  import('@/features/atividade').then((m) => ({ default: m.AtividadeConfigAreas })),
);
const AtividadeTipo = lazy(() =>
  import('@/features/atividade').then((m) => ({ default: m.AtividadeTipo })),
);

function AtividadeConsultorView() {
  const { actions } = useNavigation();
  return <Calendar onBack={actions.goBack} />;
}

function AtividadeConfigAreasView() {
  const { actions } = useNavigation();
  return <AtividadeConfigAreas onBack={actions.goBack} />;
}

function AtividadeConfigTiposView() {
  const { actions } = useNavigation();
  return <AtividadeTipo onBack={actions.goBack} />;
}

export const atividadeViews: Partial<ViewRegistry> = {
  'atividade-consultor': { component: AtividadeConsultorView, guard: {} },
  'atividade-config-areas': { component: AtividadeConfigAreasView, guard: {} },
  'atividade-config-tipos': { component: AtividadeConfigTiposView, guard: {} },
};
